import React from 'react'
import {ReactComponent as Delete} from 'style/asset/bin.svg'
import cx from 'classnames'
import withStyles from '@material-ui/core/styles/withStyles'
import iconStyle from 'component/icon/iconStyle'
import PropTypes from 'prop-types'

const DeleteIcon = (props) => {
  const {className, classes, ...rest} = props

  return <Delete {...rest} className={cx(className, classes.editIcon)} />
}

DeleteIcon.propTypes = {
  className: PropTypes.object,
  classes: PropTypes.object,
  rest: PropTypes.object,
}

export default withStyles(iconStyle)(DeleteIcon)
